module.exports = __webpack_public_path__ + "static/media/BizTechFrame4.c2e8c9ab.png";